import { DateYmd } from 'hydra-data-types';
import React, { ReactElement } from 'react';
import { stripUndefined } from 'ts-utils';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { dispatchUserData } from '../../store/userData/UserDataActions';
import { Analytics } from '../../util/Analytics';
import { NavigationProps } from './FlowNavigation';
import { DateOfBirthLayout, DateOfBirthLayoutConfig } from './layouts/DateOfBirthLayout';
import { getDateOfBirthUserData } from './layouts/DateOfBirthUtils';

export type DateOfBirthScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.DateOfBirth,
  DateOfBirthLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  DateOfBirthScreenConfig<ScreenNames>,
  ScreenNames
>;

export const DateOfBirthScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  function onSubmitPress(value: DateYmd): void {
    const { screenName, navigation } = props;

    dispatchUserData(getDateOfBirthUserData(screenName, value));
    // DOB is always PII so no `answer` value is included in analytics event
    Analytics.track({
      event: Analytics.Event.o_question_answered,
      ...stripUndefined({ question: screenName }),
    });

    navigation.next(props);
  }

  return (
    <DateOfBirthLayout
      {...props.layout}
      onPressPrimaryButton={onSubmitPress}
      primaryButtonTitle="Next"
    />
  );
};
